"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleAppSearchCreateSchema = exports.CreateAppleiTunesSearchResultsSchema = exports.AppleAppSearchResultResponseSchema = exports.AppleAppSearchFindQuerySchema = exports.AppleAppSearchLookupParamsSchema = exports.AppleAppSearchResultSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_itunes_1 = require("./apple-itunes");
const campaigns_1 = require("./campaigns");
const core_2 = require("./core");
exports.AppleAppSearchResultSchema = (0, core_1.StrictObject)({
    id: ruby_1.AppleProxyRefSchema,
    title: typebox_1.Type.String(),
    artistId: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    sellerName: typebox_1.Type.String(),
    developerName: typebox_1.Type.String(),
    companyUrl: typebox_1.Type.Optional(core_1.UrlSchema),
    genreIds: typebox_1.Type.Array(ruby_1.AppleProxyRefSchema),
    countries: typebox_1.Type.Array(core_1.CountrySchema),
    artworkUrls: typebox_1.Type.Array(core_1.UrlSchema),
    screenshotUrls: typebox_1.Type.Array(core_1.UrlSchema),
    ipadScreenshotUrls: typebox_1.Type.Array(core_1.UrlSchema),
});
exports.AppleAppSearchLookupParamsSchema = (0, core_1.StrictObject)({
    id: ruby_1.AppleProxyRefSchema,
});
exports.AppleAppSearchFindQuerySchema = (0, core_1.StrictObject)({
    query: core_1.SearchStringSchema,
});
exports.AppleAppSearchResultResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleAppSearchResultSchema);
exports.CreateAppleiTunesSearchResultsSchema = (0, core_1.StrictObject)({
    id: ruby_1.AppleProxyRefSchema,
    updatedAt: core_2.AppleProxyDateTimeSchema,
});
exports.AppleAppSearchCreateSchema = (0, core_1.StrictObject)({
    country: campaigns_1.AppleProxyCountryOrRegionSchema,
    appData: apple_itunes_1.AppleiTunesLookupResultsSchema,
});
